export default "__VITE_ASSET__BJ_Mn7GF__"